import moment from "moment";
import service from "~api/project";
import * as types from "../types";

const loop = (data, level) =>
  data.filter(v => {
    v.label = v.menuName;
    v.value = v.id;
    v.is_shown = false;
    v.is_level = level;
    if (v.childrenList.length > 0) {
      const arr = loop(v.childrenList, level + 1);
      v.children = arr.sort((a, b) => a.menuOrder < b.menuOrder);
    }
    return level < 3;
  });

export default {
  getProjectList({ commit }, payload) {
    return service.apiGetProjectList(payload).then(res => {
      if (res.data) {
        if (res.data.results) {
          res.data.results.forEach(item => {
            item.importDeadline = moment(item.importDead).format("YYYY-MM-DD");
            item.onlineDate = moment(item.onlineDate).format("YYYY-MM-DD");
          });
        }
        commit(types.GET_PROJECT_DATALIST, res.data);
      }
    });
  },
  getCrmProjectList({ commit }, payload) {
    return service.apiGetCrmProjectList(payload).then(res => {
      if (res.data) {
        if (res.data.results) {
          res.data.results.forEach(item => {
            item.importDeadline = moment(item.importDead).format("YYYY-MM-DD");
            item.onlineDate = moment(item.onlineDate).format("YYYY-MM-DD");
          });
        }
        commit(types.GET_CRM_PROJECT_DATALIST, res.data);
      }
    });
  },
  getProjectDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      service.apiGetProjectDetail(payload).then(res => {
        const isSeparateArr = ["不隔离", "隔离"];
        if (res.data) {
          res.data.projectDetailVO.onlineDate = moment(
            res.data.projectDetailVO.onlineDate,
          ).format("YYYY-MM-DD");
          res.data.projectDetailVO.importDeadline = moment(
            res.data.projectDetailVO.importDeadline,
          ).format("YYYY-MM-DD");
          res.data.projectDetailVO.serviceDeadline = moment(
            res.data.projectDetailVO.serviceDeadline,
          ).format("YYYY-MM-DD");
          res.data.projectDetailVO.isSeparate =
            isSeparateArr[res.data.projectDetailVO.isSeparate];
          commit(types.GET_PROJECT_DETAIL, res.data);
          resolve(res.data);
        }
      });
    });
  },
  getProjectPackage({ commit }, payload) {
    return service.apiGetPackage(payload).then(res => {
      const arr = [];
      const selfArr = ["", "不限", "只能本人使用"];

      if (res.data) {
        if (res.data.data) {
          res.data.data.forEach((item, index) => {
            let isNewProject = true;

            if (item.packageDetails.length > 0) {
              item.packageDetails.forEach(v => {
                arr.push({
                  ...v,
                  isNewProject,
                  len: item.packageDetails.length,
                  selfUse: selfArr[v.selfUse],
                  packageCode: item.packageCode,
                  packageName: item.packageName,
                  gmtCreatedStr: item.gmtCreatedStr,
                });
                isNewProject = false;
              });
            }
          });
        }
        console.log("arr", arr);
        commit(types.GET_PROJECT_PACKAGELIST, arr);
      }
    });
  },
  getProjectTeams({ commit }, payload) {
    return service.apiGetQueryTeam(payload).then(res => {
      if (res.data) {
        const func = data =>
          data.forEach(item => {
            if (item.children.length === 0) {
              delete item.children;
            } else {
              func(item.children);
            }
          });
        func(res.data.children);
        const arr = [
          {
            ...res.data,
            children: res.data.children,
          },
        ];

        commit(types.GET_PROJECT_TEAM, arr);
      }
    });
  },
  getProjectSelect({ commit }, payload) {
    return service.apiGetProjectSelect(payload).then(res => {
      const list = res.data.data.filter(v => v.projectName);
      commit(types.GET_PROJECT_LIST_SELECT, list);
    });
  },
  getCustomerSelect({ commit, state }, payload) {
    const { pageNumber } = payload;
    return service.apiGetCustomerSelect(payload).then(res => {
      // 如果非第一页，则合并之前的数据
      if (pageNumber > 1) {
        res.data.results = [
          ...state.projectCustomerSelect,
          ...res.data.results,
        ];
      }

      commit(types.GET_PROJECT_CUSTOMER, res.data);
      commit(types.GET_PROJECT_CUSTOMER_SELECT, res.data.results);
    });
  },
  getContractSelect({ commit }, payload) {
    return service.apiGetContractSelect(payload).then(res => {
      commit(types.GET_PROJECT_CONTRACT_SELECT, res.data.results);
    });
  },
  getSalesmanSelect({ commit }, payload) {
    return service.apiGetSalesmanSelect(payload).then(res => {
      if (res.data) {
        commit(types.GET_PROJECT_SALESMAN_SELECT, res.data.data);
      }
    });
  },
  deleteProject({ commit }, payload) {
    return service.apiDeleteProject(payload);
  },
  addProject({ commit }, payload) {
    return service.apiAddProject(payload);
  },
  updateProject({ commit }, payload) {
    return service.apiUpdateProject(payload);
  },
};
